import React, { useState } from "react";
import { acceptTerms } from "../../auth/firebaseAuth";
import "../../styles/ui.css";

// Shown on the board to a member who hasn't accepted the current Terms of
// Service (e.g. an invited caregiver on first sign-in). They must agree before
// they can post messages — this is the per-user HIPAA-responsibility consent.
export default function TermsGate({ onAccepted }) {
  const [checked, setChecked] = useState(false);
  const [phiChecked, setPhiChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const accept = async () => {
    if (!checked || !phiChecked) { setError("Please check both boxes to continue."); return; }
    setBusy(true); setError(null);
    try {
      await acceptTerms();
      onAccepted && onAccepted();
    } catch (e) {
      setBusy(false);
      setError("Could not record your acceptance. Please try again.");
    }
  };

  return (
    <div className="mui">
      <div className="mui-card">
        <h3 className="mui-title" style={{ marginBottom: "0.6rem" }}>Before you start</h3>
        <p className="mui-muted" style={{ margin: 0 }}>
          As a Care Circle member you are responsible for ensuring the messages you post are appropriate
          and comply with the care facility's policies and applicable law — for example, limiting
          sensitive personal information to what belongs on a screen in your loved one's room.
        </p>
        <label className="mui-check" style={{ margin: "1.25rem 0 0.9rem" }}>
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>I have read and agree to the{" "}
            <a href="/terms" target="_blank" rel="noreferrer" className="mui-link">Terms of Service</a>, and I
            accept responsibility for keeping the messages I post HIPAA-compliant.</span>
        </label>
        <label className="mui-check" style={{ margin: "0 0 1.6rem" }}>
          <input type="checkbox" checked={phiChecked} onChange={(e) => setPhiChecked(e.target.checked)} />
          <span><strong>I will not post protected health information (PHI)</strong> — no diagnoses,
            conditions, medications, treatments, or other private medical details — in messages or
            photos. This board is shown openly on a screen in the room; keep posts to everyday,
            non-clinical notes and pictures.</span>
        </label>
        <button className="mui-btn mui-btn-primary mui-btn-block" style={{ marginTop: "0.25rem" }} onClick={accept} disabled={busy || !checked || !phiChecked}>
          {busy ? "Please wait…" : "Agree & continue"}
        </button>
        {error && <p className="mui-msg mui-error">{error}</p>}
      </div>
    </div>
  );
}
